module.exports = __webpack_public_path__ + "img/got-a-balance.c5a44e8e.png";